import { Injectable } from '@angular/core';
import { ApiEndpoints } from '../../constants/api-endpoints.config';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeaderboardService {

  private apiEndPoint: any = ApiEndpoints;
  url: string = environment.apiurls.baseUrl;

  constructor(
    private apiService: ApiService
  ) { }

  getLeaderBoardRanking(duration: any, pageNo: number = 1, pageSize: number = 10): Observable<any> {
    return this.apiService.get(
      `${this.url}${this.apiEndPoint.leaderboard.getLeadboardRanking}${duration}&pageNo=${pageNo}&pageSize=${pageSize}`
    );
  }

  /**
   * This function is used get all leaderboard list.
   * @returns
   */
  getAllLeaderBoardList(pageNo: number = 1, pageSize: number = 10): Observable<any> {
    return this.apiService.get(
      `${this.url}${this.apiEndPoint.leaderboard.getAllLeaderBoard}?pageNo=${pageNo}&pageSize=${pageSize}`
    );
  }

  /**
   * This function is used to get list by search.
   * @param query
   * @returns
   */
  getLeaderBoardListBySearch(query: any, pageNo: number = 1, pageSize: number = 10): Observable<any> {
    return this.apiService.get(
      `${this.url}${this.apiEndPoint.leaderboard.searchQuery}${query}&pageNo=${pageNo}&pageSize=${pageSize}`
    );
  }
}
